import React, { useState } from 'react';
import { Menu, Globe } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
export function Header() {
  const {
    language,
    setLanguage,
    t
  } = useLanguage();
  const [showLangMenu, setShowLangMenu] = useState(false);
  return <header className="w-full py-4 px-6 md:px-12 flex justify-between items-center bg-brand-bg/80 backdrop-blur-md sticky top-[52px] sm:top-[40px] z-40 border-b border-white/5" data-id="element-150">
      <div className="flex items-center" data-id="element-151">
        <img src="https://cdn.magicpatterns.com/uploads/wwrePDBPWqppwukFQGcq8H/logo_kinetic_.png" alt="Kinetic Growth Studio Logo" className="h-10 md:h-12 object-contain" data-id="element-152" />
      </div>

      <nav className="hidden md:flex items-center gap-8 text-sm font-medium text-gray-300" data-id="element-153">
        <a href="#sistema" className="hover:text-brand-cyan transition-colors" data-id="element-154">
          {t('nav.sistema')}
        </a>
        <a href="#planes" className="hover:text-brand-cyan transition-colors" data-id="element-155">
          {t('nav.planes')}
        </a>
        <a href="#testimonios" className="hover:text-brand-cyan transition-colors" data-id="element-156">
          {t('nav.testimonios')}
        </a>
        <a href="#quienes-somos" className="hover:text-brand-cyan transition-colors" data-id="element-157">
          {t('nav.quienes')}
        </a>
        <a href="#faq" className="hover:text-brand-cyan transition-colors" data-id="element-158">
          {t('nav.faq')}
        </a>
      </nav>

      <div className="flex items-center gap-4" data-id="element-159">
        <div className="relative" data-id="element-160">
          <button onClick={() => setShowLangMenu(!showLangMenu)} className="flex items-center gap-2 bg-white/5 hover:bg-white/10 border border-white/10 px-3 py-2 rounded-full transition-all duration-300" data-id="element-161">
            <Globe className="w-4 h-4 text-brand-cyan" data-id="element-162" />
            <span className="text-sm font-medium text-white uppercase" data-id="element-163">
              {language}
            </span>
          </button>

          {showLangMenu && <div className="absolute right-0 mt-2 bg-brand-darker border border-white/10 rounded-xl overflow-hidden shadow-lg min-w-[120px]" data-id="element-164">
              <button onClick={() => {
            setLanguage('es');
            setShowLangMenu(false);
          }} className={`w-full px-4 py-2 text-left hover:bg-white/5 transition-colors ${language === 'es' ? 'bg-brand-cyan/10 text-brand-cyan' : 'text-gray-300'}`} data-id="element-165">
                Español
              </button>
              <button onClick={() => {
            setLanguage('en');
            setShowLangMenu(false);
          }} className={`w-full px-4 py-2 text-left hover:bg-white/5 transition-colors ${language === 'en' ? 'bg-brand-cyan/10 text-brand-cyan' : 'text-gray-300'}`} data-id="element-166">
                English
              </button>
            </div>}
        </div>

        <a href="#contacto" className="hidden md:flex bg-transparent border border-brand-cyan text-brand-cyan hover:bg-brand-cyan/10 px-5 py-2 rounded-full font-medium transition-all duration-300" data-id="element-167">
          {t('nav.contact')}
        </a>
        <button className="md:hidden text-white p-2" data-id="element-168">
          <Menu className="w-6 h-6" data-id="element-169" />
        </button>
      </div>
    </header>;
}